import React from 'react';
import brand1 from '../static/images/brands/brand1.png';
import brand2 from '../static/images/brands/brand2.png';
import brand3 from '../static/images/brands/brand3.png';
import { useTranslation } from 'react-i18next';

export default function PartnerBrands() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className='mt-16 mb-2 w-full lg:w-[1000px]'>
        <h1 className="text-[#225424] hidden xl:block">{t('Homepage.ourPartnersTitle')}</h1>
        <h2 className="text-[#225424] hidden md:block xl:hidden">{t('Homepage.ourPartnersTitle')}</h2>
        <h3 className="text-[#225424] md:hidden">{t('Homepage.ourPartnersTitle')}</h3>
      </div>
      <div className='
        w-full px-8
        lg:w-[1000px]
        h-48
        overflow-x-auto
        flex items-center justify-start lg:justify-center gap-8
        '>
        <img src={brand1} alt="Brand 1" className='w-48 object-contain' />
        <img src={brand2} alt="Brand 2" className='w-48 object-contain' />
        <img src={brand3} alt="Brand 3" className='w-48 object-contain' />
      </div>
    </React.Fragment>

  )
}
